import React from "react";

import usePageSeo from "../hooks/usePageSeo";
const ReturnPolicy = () => {
  usePageSeo({
    title: "Return & Refund Policy | FMart Korea",
    description: "FMart Korea return and refund policy for halal groceries and meat — how to request a return, refund timelines and what is covered.",
  });

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Return Policy - FMartKorea</h1>

      <section className="mb-5">
        <p className="text-muted">
          FMartKorea (hereinafter referred to as “the Company”) strives to provide
          the best shopping experience. Please review the following return policy
          carefully before making a request.
        </p>
      </section>

      <section className="mb-5">
        <h4>1. Address for Returns</h4>
        <p className="text-muted">
          경기도 양주시 광적면 가래비길 51, 1층 102호 (FMart)
        </p>
      </section>

      <section className="mb-5">
        <h4>2. Product Details Page</h4>
        <p className="text-muted">
          Every product page must include:
        </p>
        <ul className="text-muted">
          <li>Delivery period (e.g. “Ships within 3–5 business days” / or “Service provided within 24 hours”)</li>
          <li>Exchange policy (e.g. “Exchanges accepted within 7 days if product is defective”)</li>
          <li>Refund/Cancellation policy (must be clearly written in Korean)</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>3. General Requirements</h4>
        <p className="text-muted">
          Returns are accepted only if they meet the conditions below. Please note
          that exchanges are not available. Refunds will be issued after inspection
          of the returned items.
        </p>
      </section>

      <section className="mb-5">
        <h4>4. Eligible for Cancellation</h4>
        <ul className="text-muted">
          <li>Return request posted within 24 hours of payment (order status: Pending).</li>
          <li>Order delayed for more than 10 days without notification.</li>
          <li>Item is out of stock.</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>5. Eligible for Return</h4>
        <ul className="text-muted">
          <li>You receive a product different from your order.</li>
          <li>You receive a defective product.</li>
        </ul>
      </section>

      <section className="mb-5">
        <h4>6. Return Instructions</h4>
        <ol className="text-muted">
          <li>Submit a return request on our Return forum within 3 days of receipt, including photos, order number, and reason for return.</li>
          <li>Our customer service team will contact you via email or phone for assistance.</li>
          <li>Items must be in their original condition (tags, labels, packaging intact) and include order details.</li>
        </ol>
        <p className="text-muted">
          * Returns shipped without prior approval will not be accepted.<br />
          * Even defective/incorrect items must be returned with tags and packaging.<br />
          * Include all original contents and free gifts, if applicable.
        </p>
      </section>

      <section className="mb-5">
        <h4>7. Shipping Fees</h4>
        <p className="text-muted">
          Shipping fees for returns due to our fault will be covered by FMartKorea.
          If EMS cash-on-delivery is unavailable, please scan and upload the return
          receipt to the forum. The fee will be refunded once the returned item is
          received.
        </p>
      </section>

      <section className="mb-5">
        <h4>8. Returns Not Accepted</h4>
        <ul className="text-muted">
          <li>Change of mind (size, color, etc.).</li>
          <li>Shoes, bags, or accessories.</li>
          <li>Products damaged due to customer mishandling.</li>
          <li>Unapproved return requests.</li>
        </ul>
        <p className="text-muted">
          The following are <strong>not considered defective:</strong><br />
          - Items originally manufactured without tags or labels<br />
          - Creases from shipping<br />
          - Minor imperfections from mass production
        </p>
      </section>

      <section className="mb-5">
        <h4>9. Missing Items</h4>
        <p className="text-muted">
          If an item is missing from your order, please contact our customer
          service within 1 day of delivery. Keep all packaging materials until you
          receive further instructions. Refunds may not be processed if packaging
          is lost or damaged.
        </p>
      </section>

      <section className="mb-4">
        <h4>10. Customer Service</h4>
        <ul className="text-muted">
          <li><strong>Customer Support:</strong> +82-10-9603-7214</li>
          <li><strong>Email:</strong> admin@fmartskorea.com</li>
        </ul>
      </section>
    </div>
  );
};

export default ReturnPolicy;
